<template>
  <div id="vista-formulario-campos-principales-acuerdo" v-if="acuerdo_comercial_copy">

    <slot name="pre-formulario"/>

    <div v-if="!modo_edicion" class="titulo-principal mb-6">Configuración del acuerdo</div>

    <!-- [ToDo] usar prop formulario para deshabilitar (versión de vuetify compatible) -->
    <v-form
      ref="formulario_creacion"
      class="formulario-creacion"
      v-model="formulario_valido"
      onSubmit="return false;"
    >

      <!-- Titulo [acuerdo_libre - no esta en uso actualmente] -->
      <template v-if="acuerdo_comercial_copy.tipo_propuesta === TIPO_ACUERDO_LIBRE && modo_edicion">
        <v-text-field
          label="Consorcio"
          placeholder="Nombre del consorcio"
          v-model="acuerdo_comercial_copy.consorcio_propuesta_libre"
          :value="acuerdo_comercial_copy.consorcio_propuesta_libre"
          counter="64"
          class="mb-4"
          :rules="regla_titulo_consorcio"
          required
        >
        </v-text-field>
      </template>

      <!-- Modalidad -->
      <!-- Se muestra si NO es por defectos y NO es masiva -->
      <template v-if="acuerdo_comercial_copy.tipo_propuesta !== TIPO_ACUERDO_POR_DEFECTO && !esMasiva">
        <div class="seccion" :disabled="formDeshabilitado">
          <div class="titulo-seccion">Modalidad</div>
          <hr class="linea-separadora">

          <!-- Queda deshabilitado con la opción seteada -->
          <div style="padding-left: 6px">
            <div v-if="acuerdo_comercial_copy.tipo_propuesta === TIPO_ACUERDO_VINCULADO_A_CONSORCIO">
              <v-radio-group disabled :value="acuerdo_comercial_copy.consorcios_seleccionados[0].solo_comunicacion" hide-details>
                <v-radio label="Sistema completo" :value=false color="accent" class="mb-3"></v-radio>
                <v-radio label="Sólo comunicación" :value=true color="accent" class="mb-3"></v-radio>
              </v-radio-group>
            </div>
            <div v-else>
              <v-radio-group v-model="acuerdo_comercial_copy.solo_comunicacion" hide-details>
                <v-radio label="Sistema completo" :value="false" color="accent" class="mb-3"></v-radio>
                <v-radio label="Sólo comunicación" :value="true" color="accent" class="mb-3"></v-radio>
              </v-radio-group>

              <ca-chip
                class="mt-2"
                v-if="acuerdo_comercial_copy.solo_comunicacion === true"
                :item="{label: 'Se aplica un 50% sobre el precio base de UF'}"
                disabled
                outline
                contentClass="chip-custom chip-informativo"
              >
                <div slot="izquierda">
                  <v-icon class="icon-info">info</v-icon>
                </div>
              </ca-chip>
            </div>
          </div>

        </div>
      </template>

      <!-- Tipo de consorcio -->
      <template v-if="acuerdo_comercial_copy.tipo_propuesta !== TIPO_ACUERDO_POR_DEFECTO && !esMasivaConDistintosTipoConsorcio">
        <div class="seccion">
          <div class="titulo-seccion">Tipo de consorcio</div>
          <hr class="linea-separadora">
          <div style="padding-left: 6px">
            <v-radio-group :disabled="acuerdo_comercial_copy.tipo_propuesta === TIPO_ACUERDO_VINCULADO_A_CONSORCIO" v-model="acuerdo_comercial_copy.tipo_producto" hide-details>
              <v-radio label="Edificio" value="edificio" color="accent" class="mb-3"></v-radio>
              <v-radio label="Barrio" value="barrio" color="accent" class="mb-3"></v-radio>
            </v-radio-group>
          </div>
        </div>
      </template>

      <!-- Unidades funcionales -->
      <div class="seccion">
        <div class="titulo-seccion">Unidades funcionales</div>
        <hr class="linea-separadora">

        <!-- Cuenta de ufs -->
        <template v-if="this.vinculadaASoloUnConsorcio">
          <div class="cuenta-ufs pt-2 ml-2">
            <span class="texto-seccion">UFs Principales: {{ this.acuerdo_comercial_copy.consorcios_seleccionados[0].cantUfsPrimarias }}</span>
            <br>
            <span class="texto-seccion">Cocheras: {{ this.acuerdo_comercial_copy.consorcios_seleccionados[0].cantidadCocheras }}</span>
          </div>
        </template>

        <div class="sub-seccion">
          <div class="contenido-sub-seccion ml-2">
            <v-checkbox
              color="accent"
              class="mb-2"
              :disabled="formDeshabilitado || (this.vinculadaASoloUnConsorcio && this.acuerdo_comercial_copy.consorcios_seleccionados[0].cantidad_ufs_facturables >= MINIMO_UFS_PLATAFORMA)"
              v-model="acuerdo_comercial_copy.minimo_ufs"
              label="Facturar debajo del mínimo de UFs"
              hide-details
            ></v-checkbox>

            <!-- Se muestra el chip si es vinculada a UN consorcio y no llega al minimo de ufs permitidas o si es por defecto -->
            <div v-if="this.vinculadaASoloUnConsorcio && this.acuerdo_comercial_copy.consorcios_seleccionados[0].cantidad_ufs_facturables < MINIMO_UFS_PLATAFORMA">
              <ca-chip
                :item="itemUfsFacturarDebajo"
                disabled
                outline
                contentClass="chip-custom chip-informativo"
              >
                <div slot="izquierda">
                  <v-icon class="icon-info">info</v-icon>
                </div>
              </ca-chip>
            </div>

            <!-- Se muestra el chip si es por defecto y factura por debajo del minimo de ufs -->
            <div v-if="(this.acuerdo_comercial_copy.tipo_propuesta === TIPO_ACUERDO_POR_DEFECTO || this.esMasiva) && this.acuerdo_comercial_copy.minimo_ufs">
              <ca-chip
                :item="{ label: 'Se aplicará en todos los consorcios seleccionados con menos de ' + this.MINIMO_UFS_PLATAFORMA + ' UFs.' }"
                disabled
                outline
                contentClass="chip-custom chip-warning"
              >
                <div slot="izquierda">
                  <v-icon class="icon-warning">warning</v-icon>
                </div>
              </ca-chip>
            </div>

          </div>
        </div>

        <!-- Descuentos temporales -->
        <descuentos-temporales
          ref="descuento_temporal"
          :descuentos_temporales.sync="descuentos_temporales"
          :deshabilitado=formDeshabilitado
        >
        </descuentos-temporales>

        <!-- Descuento permanente -->
        <descuento-permanente
          ref="descuentos_permanentes_uf"
          :descuento_permanente.sync="descuento_permanente_uf"
          :deshabilitado=formDeshabilitado
        >
        </descuento-permanente>
      </div>

      <!-- Cocheras -->
      <template v-if="mostrarSeccionCocheras">
        <div class="seccion">
          <div>
            <div class="titulo-seccion">Cocheras</div>
            <hr class="linea-separadora">
          </div>
          <descuento-permanente
            ref="descuentos_permanentes_cocheras"
            :descuento_permanente.sync="descuento_permanente_cocheras"
            :deshabilitado=formDeshabilitado
          >
            <div slot="mensaje-informativo" v-if="(algunConsorcioEsBarrioSiendoMasiva || acuerdo_comercial_copy.tipo_propuesta === TIPO_ACUERDO_POR_DEFECTO) && descuento_permanente_cocheras">
              <ca-chip
                :item="{'label': 'Esta sección sólo tendrá efecto sobre edificios.'}"
                disabled
                outline
                contentClass="chip-custom chip-informativo"
              >
                <div slot="izquierda">
                  <v-icon class="icon-info">info</v-icon>
                </div>
              </ca-chip>
            </div>
          </descuento-permanente>
        </div>
      </template>

      <!-- Primer mes de facturación -->
      <template v-if="acuerdo_comercial_copy.tipo_propuesta === TIPO_ACUERDO_VINCULADO_A_CONSORCIO">
        <div class="seccion" ref="periodo_inicio_facturacion">
          <div class="titulo-seccion">Primer mes de facturación</div>
          <hr class="linea-separadora">

          <ca-input-datepicker
            label="Período"
            type="month"
            format="MMMM yyyy"
            clearable
            :fecha.sync="acuerdo_comercial_copy.periodo_inicio_facturacion"
            class="mt-2"
            :disabled="formDeshabilitado"
            destacarFecha
            required
          />

          <!-- Chip warning cuando periodo seleccionado es menor o igual al actual -->
          <ca-chip
            v-if="activarWarningPeriodoActualPosteriorFacturacion.activar && !formDeshabilitado"
            :item="activarWarningPeriodoActualPosteriorFacturacion.msg"
            disabled
            outline
            contentClass="chip-custom chip-warning mt-3"
          >
            <div slot="izquierda">
              <v-icon class="icon-warning">warning</v-icon>
            </div>
          </ca-chip>

          <!-- Chip informativo para acuerdos masivas -->
          <ca-chip
            v-if="!!acuerdo_comercial_copy.periodo_inicio_facturacion && esMasiva"
            disabled
            outline
            contentClass="chip-custom chip-informativo mt-3"
          >
            <div slot="izquierda">
              <v-icon class="icon-info">info</v-icon>
            </div>

            <template>
              <span>Se utilizará la misma observación para todos los consorcios. Podés editar cada acuerdo individualmente desde la sección Buscador.</span>
            </template>
          </ca-chip>

        </div>
      </template>

      <!-- Observaciones para facturación [solo edición] -->
      <template v-if="modo_edicion && acuerdo_comercial_copy.tipo_propuesta !== TIPO_ACUERDO_POR_DEFECTO">
        <div class="mt-6">
          <div class="titulo-seccion">Observaciones para facturación</div>
          <hr class="linea-separadora mb-2">
          <v-textarea
            no-resize
            outlined
            rounded
            placeholder="Este es un comentario para el área de facturación al respecto de este acuerdo."
            v-model="acuerdo_comercial_copy.observaciones"
            hint="Opcional"
            persistent-hint
            maxlength="255"
            counter="255"
            :disabled="formDeshabilitado"
          >
          </v-textarea>
        </div>
      </template>

    </v-form>
  </div>
</template>

<script>
import { AcuerdoComercial } from '../../../../models/AcuerdoComercial';
import * as acuerdo_comercial_constantes from '../../acuerdo-comercial.consts';
import { helperDestructurarDescuentosUfs } from '../../acuerdo-comercial.helpers';
import DescuentosTemporales from './secciones/DescuentosTemporales.vue';
import DescuentoPermanente from './secciones/DescuentoPermanente.vue';
import { METADATA_GETTER_MINIMO_UFS_PLATAFORMA } from '@/store/metadata/metadata.types';

export default {
  name: 'VistaFormularioCamposPrinicipalesAcuerdo',
  components:{
    DescuentosTemporales,
    DescuentoPermanente
  },
  props:{
    acuerdo_comercial: { type: AcuerdoComercial, default: () => new AcuerdoComercial() },
    modo_edicion: { type: Boolean, default: false },
  },
  data() {
    return {
      acuerdo_comercial_copy: null,

      // Descuentos
      descuentos_temporales: [], // Arreglo para almacenar los descuentos temporales (dependiendo del length sera el codigo html renderizado)
      descuento_permanente_uf: null, // Solo puede haber un descuento de tipo permanente para uf principales
      descuento_permanente_cocheras: null, // Solo puede haber un descuento de tipo permanente para cocheras

      // Reglas formulario
      regla_titulo_consorcio: [
        titulo => !!titulo || 'El nombre del consorcio es necesario',
        titulo => (titulo && titulo.length <= 64) || 'El nombre del consorcio no puede superar los 64 caracteres.'
      ],
      formulario_valido: true, // Flag para saber si el formulario es valido

      // Constantes usadas en el template
      TIPO_ACUERDO_LIBRE: acuerdo_comercial_constantes.TipoAcuerdo.LIBRE, // [acuerdo_libre - no esta en uso actualmente]
      TIPO_ACUERDO_POR_DEFECTO: acuerdo_comercial_constantes.TipoAcuerdo.ADMINISTRACION,
      TIPO_ACUERDO_VINCULADO_A_CONSORCIO: acuerdo_comercial_constantes.TipoAcuerdo.CONSORCIO,
      TIPO_EDIFICIO: acuerdo_comercial_constantes.TipoConsorcio.EDIFICIO,
      TIPO_BARRIO: acuerdo_comercial_constantes.TipoConsorcio.BARRIO,

      // Constante para el valor del minimo de ufs permitidos en la plataforma (necesario para utilizarlo en template)
      MINIMO_UFS_PLATAFORMA: this.$store.getters[METADATA_GETTER_MINIMO_UFS_PLATAFORMA]
    };
  },
  computed:{

    /**
     * Computed para calcular el texto del Chip en el apartado de unidades funcionales
     */
    itemUfsFacturarDebajo(){
      if (this.acuerdo_comercial_copy.tipo_propuesta === this.TIPO_ACUERDO_POR_DEFECTO) {
        return { label: 'Se aplicará en todos los consorcios seleccionados con menos de ' + this.MINIMO_UFS_PLATAFORMA + ' UFs.' };
      }
      // Si esta vinculada a unicamente UN consorcio y tiene menos de 20 ufs, PERO no esta chequeado el checkbox se facturan las 20 ufs como base
      return (this.vinculadaASoloUnConsorcio && this.acuerdo_comercial_copy.consorcios_seleccionados[0].cantidad_ufs_facturables < this.MINIMO_UFS_PLATAFORMA && !this.acuerdo_comercial_copy.minimo_ufs) ?
        {
          label: 'Se facturará el mínimo: ' + this.MINIMO_UFS_PLATAFORMA +' UFs'
        }
        :
        {
          label: 'Se facturarán ' +  this.acuerdo_comercial_copy.consorcios_seleccionados[0].cantidad_ufs_facturables + ' UFs'
        };
    },

    /**
     * Computed para calcular si es acuerdo vinculado pero masivamente
     */
    esMasiva(){
      return (this.acuerdo_comercial_copy && this.acuerdo_comercial_copy.tipo_propuesta === this.TIPO_ACUERDO_VINCULADO_A_CONSORCIO && this.acuerdo_comercial_copy.consorcios_seleccionados && this.acuerdo_comercial_copy.consorcios_seleccionados.length > 1);
    },

    /**
     * Computed para calcular si es acuerdo vinculado unicamente a un consorcio
     */
    vinculadaASoloUnConsorcio(){
      return !this.esMasiva && this.acuerdo_comercial_copy.consorcios_seleccionados && this.acuerdo_comercial_copy.consorcios_seleccionados.length === 1;
    },

    /**
     * Computed para definir cuando se tiene que deshabilitar el formulario (Modo edición)
     */
    formDeshabilitado(){
      // Deshabilito el formulario completo si es un acuerdo vinculado a un consorcio y ya esta facturando [caso edicion]
      if (this.modo_edicion && this.acuerdo_comercial_copy.tipo_propuesta === this.TIPO_ACUERDO_VINCULADO_A_CONSORCIO){
        return this.acuerdo_comercial_copy.consorcios_seleccionados[0].facturando;
      }
      return false;
    },

    /**
     * Computed para calcular si es necesario mostrar el chip de warning 
     * Este chip se muestra en caso que la fecha de facturación sea igual o anterior al periodo actual
     */
    activarWarningPeriodoActualPosteriorFacturacion(){

      if (this.acuerdo_comercial_copy.periodo_inicio_facturacion){

        // Obtengo la fecha de hoy, el mes y el anio
        let fecha_actual = new Date();
        let mes_actual = fecha_actual.getMonth()+1;
        let anio_actual = fecha_actual.getFullYear();

        // Obtengo el mes y el anio del periodo seleccionado
        let fecha_seleccionada = new Date(this.acuerdo_comercial_copy.periodo_inicio_facturacion);
        fecha_seleccionada.setDate(fecha_seleccionada.getDate() + 1); // Sumo un dia para que no me tome el mes anterior
        let mes_seleccionado = fecha_seleccionada.getMonth()+1;
        let anio_seleccionado = fecha_seleccionada.getFullYear();

        // Verifico primero el anio o puede que sean iguales pero el mes no INCUMPLE la condición
        if (anio_seleccionado > anio_actual || (anio_seleccionado === anio_actual && mes_seleccionado > mes_actual)){
          return {activar: false, msg: {label: ''}};
        }

        if (anio_seleccionado === anio_actual && mes_seleccionado === mes_actual){
          let mensaje = '<b>El período esta en curso</b><br>';
          mensaje += this.esMasiva ? 'Es posible que los consorcios seleccionados no se facturen en el próximo período.' : 'Es posible que este consorcio no se facture en el próximo período.';
          return {activar: true, msg: {label: mensaje}};
        }
        else{
          let mensaje = '<b>El período está finalizado</b><br>';
          mensaje += this.esMasiva ? 'Los consorcios seleccionados no se van a facturar.' : 'Este consorcio no se va a facturar.';
          return {activar: true, msg: {label: mensaje}};
        }
      }

      return {activar: false, msg: {label: ''}};
    },

    /**
     * Computed para calcular si se debe mostrar la sección de cocheras en base al acuerdo comercial
     * Puede que sea una asignación masiva, por lo tanto, pueden exitir consorcios de tipo edificio y barrios
     * Los descuentos de cocheras solo aplican a edificios
     */
    mostrarSeccionCocheras(){
      const activar_seccion_cochera = this.esMasiva ? this.acuerdo_comercial_copy.consorcios_seleccionados.some(consorcio => consorcio.tipo === this.TIPO_EDIFICIO) : this.acuerdo_comercial_copy.tipo_producto !== this.TIPO_BARRIO;

      return activar_seccion_cochera && !(this.formDeshabilitado && !this.descuento_permanente_cocheras);
    },

    /**
     * Computed para saber si en el total de consorcios seleccionados existe alguno que es un barrio
     */
    algunConsorcioEsBarrioSiendoMasiva(){
      if (this.esMasiva){
        return this.acuerdo_comercial_copy.consorcios_seleccionados.some(consorcio => consorcio.tipo === this.TIPO_BARRIO);
      }
      return this.acuerdo_comercial_copy.tipo_producto === this.TIPO_BARRIO;
    },

    /**
     * Computed para saber si es un acuerdo masiva y los consorcios afectados tiene distintos tipos entre si
     */
    esMasivaConDistintosTipoConsorcio(){
      if (this.esMasiva){
        const tipo_consorcio = this.acuerdo_comercial_copy.consorcios_seleccionados[0].tipo;
        return this.acuerdo_comercial_copy.consorcios_seleccionados.some(consorcio => consorcio.tipo !== tipo_consorcio);
      }
      return false;
    }
  },
  watch:{
    /**
     * Watch necesario para detectar cambios (solo en la edición)
     */
    acuerdo_comercial_copy(new_value){
      if (this.modo_edicion){
        this.$emit('update:acuerdo_comercial', new_value);
      }
    },

    formulario_valido(new_value){
      this.$emit('formulario-campos-principales:valido', new_value);
    },

    /**
     * Watch para detectar que en caso que sea nula la observación, se setee como null y no como un string vacio (para que no lo detecte como cambio)
     */
    'acuerdo_comercial_copy.observaciones'(new_value){
      if (new_value === ''){
        this.acuerdo_comercial_copy.observaciones = null;
      }
    },

    /**
     * Watchs necesario para detectar los cambios cuando se agrega una descuento tanto temporal como permanente
     */
    descuentos_temporales: {
      deep: true,
      handler() {
        this.estructuracionDescuentosUfs();
      }
    },

    descuento_permanente_uf: {
      deep: true,
      handler() {
        this.estructuracionDescuentosUfs();
      }
    },

    descuento_permanente_cocheras: {
      deep: true,
      handler() {
        this.estructuracionDescuentosUfs();
      }
    }
  },
  /**
   * Al montarse el componente, se precarga la vista con los campos del acuerdo comercial
   */
  mounted(){
    this.preCargarCreacion(this.acuerdo_comercial);
  },
  methods:{
    /**
     * Metodo invocado desde el padre, para validar el formulario
     * EN caso que sea valido
     *  - Se emite evento para actualizar el AC con los campos rellenos
     *    - Para eso se estructura los descuentos para asignarselos al AC
     *  - Se retona verdadero
     * En caso de que NO sea valido
     *   - Se retorna false
     */
    validarFormulario(){
      this.$refs.formulario_creacion.validate();

      if (this.formulario_valido){
        this.estructuracionDescuentosUfs(); // Estructo los descuentos con el formato para enviar
        this.$emit('update:acuerdo_comercial', this.acuerdo_comercial_copy);
      }
      else{ // Como el formulario no es valido, ubico el scroll sobre la sección obligatoria
        this.scrollPeriodoInicioFacturacion();
      }

      return this.formulario_valido;
    },

    /**
     * Metodo que permite usar esta vista del sidesheet pre cargando el acuerdo comercial
     * Esto se hace para poder editar el acuerdo comercial cuando esta ultima se pasa por props
     * Consta de reiniciar todos los campos, y luego rellenarlos con el acuerdo comercial pasada
     *
     * @param acuerdo_comercial_a_precargar - AC con el cual se rellenará los campos
     */
    preCargarCreacion(acuerdo_comercial_a_precargar){

      this.acuerdo_comercial_copy = _.cloneDeep(acuerdo_comercial_a_precargar);

      // calculo los descuentos, para rellenar variables locales de esta vista
      this.destructurarDescuentosUfs();

      // Si se quiere reiniciar los acuerdos comerciales, reinicio todos los descuentos tambien (necesario usar los refs porque los componentes hijos no detectan el cambio en los descuentos)
      if(acuerdo_comercial_a_precargar && this.$refs.descuento_temporal && this.$refs.descuentos_permanentes_uf && this.$refs.descuentos_permanentes_cocheras){
        this.$refs.descuento_temporal.actualizarDescuentosTemporales(this.descuentos_temporales);
        this.$refs.descuentos_permanentes_uf.actualizarDescuentoPermanente(this.descuento_permanente_uf);
        this.$refs.descuentos_permanentes_cocheras.actualizarDescuentoPermanente(this.descuento_permanente_cocheras);
      }
    },

    /**
     * Metodo para calcular los descuentos en el formato para el POST de acuerdo
     * Permanentes: se setean directamente en descuentos.
     * Temporales: se setean en el arreglo de periodos repitiendo x la cantidad de meses el descuento
     */
    estructuracionDescuentosUfs(){
      let descuentos = {};

      // Descuentos permanentes (no uso ifs ternarios para no crear atributos vacios)
      if (this.descuento_permanente_uf || this.descuento_permanente_cocheras){
        descuentos.tipos = {};
        if (this.descuento_permanente_uf){
          descuentos.tipos.general = parseInt(this.descuento_permanente_uf);
        }
        if (this.descuento_permanente_cocheras){
          descuentos.tipos.cochera = parseInt(this.descuento_permanente_cocheras);
        }
      }

      // Descuentos temporales
      if (this.descuentos_temporales.length){
        let meses = [];
        this.descuentos_temporales.forEach((descuento_temporal) => {
          for (let i = 0; i < descuento_temporal['meses']; i++) {
            meses.push(parseInt(descuento_temporal['descuento']));
          }
        });

        descuentos.periodos = meses;
      }

      this.acuerdo_comercial_copy.descuentos_ufs = Object.keys(descuentos).length === 0 ? null : descuentos;
    },

    /**
     * Destructuro los descuentos temporales / permanentes
     * En otras palabas, se busca separar en variables para poder mostrarlos en la vista previa de mejor manera
     * Seria destructurar lo que se creo pero solo para ser mostrado
     */
    destructurarDescuentosUfs(){
      if(this.acuerdo_comercial_copy.descuentos_ufs){
        let descuentos = helperDestructurarDescuentosUfs(this.acuerdo_comercial_copy);
        [this.descuentos_temporales, this.descuento_permanente_uf, this.descuento_permanente_cocheras] = [...descuentos];
      }
      else{
        this.descuentos_temporales= [];
        this.descuento_permanente_uf= null;
        this.descuento_permanente_cocheras= null;
      }
    },

    /**
     * Método ubicar el scroll sobre la sección del periodo de inico de facturación
     */
    scrollPeriodoInicioFacturacion(){
      const seccion_periodo_inicio_facturacion = this.$refs.periodo_inicio_facturacion;
      if (seccion_periodo_inicio_facturacion){
        seccion_periodo_inicio_facturacion.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
  },
};
</script>

<style lang="scss">
#vista-formulario-campos-principales-acuerdo {

  .formulario-creacion {

    .container-descuento{
      background-color: color(fondo-claro);
      margin-bottom: 8px;
    }
  }

  .input-descuento {
    width: 110px;
    margin-left: 16px;
    margin-right: 16px;
  }

  .chip-custom {
    margin-left: 0;
    padding: 8px 12px !important;
    .v-chip__content {
      margin: 0 !important;
    }
  }

  .ca-chip .ca-chip-izquierda {
    padding-right: 6px !important;
  }

}
</style>